import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { post } from '../../utils/api'

import { isMobile, SERVER_URL } from '../../config';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import ProdSdBnComp from '../../components/SideBanner/ProdSdBnComp';

import sty from './ProdDownPage.module.css';

const ProdDownPage = () => {

  const [ filePwd, setFilePwd ] = useState('');
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const idx = parseInt(searchParams.get("idx"));
  
  const onPwdHandler = (e) => {
    setFilePwd(e.currentTarget.value);
  };

  const onSubmit = async () => {
    try {
      await post('/product/download', {
        idx: idx,
        passwd: filePwd
      })
      .then((response) => {
        if(response.data.result === true) {
          window.location.href = SERVER_URL + response.data.path;
        } else {
          alert('비밀번호 오류입니다.');
        }
      });
    } catch(err) {
      console.log(err);
    };
  };

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 327);
    };
  
    setTimeout(scrollToTop, 0);
    }, [location]);
    
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
  }, [location]);

  return (
    <>
        <HeaderComponents pageKey="product" />
        <div className="inner-container">
          <ProdSdBnComp location={location} />

          <div className="prod-list-div" style={{minHeight:'650px'}}>
            
            <div className={`flex-column mt-100 ${sty.pwdDiv}`} draggable>
              <div className={sty.pwdTitle}>
                리더기 제품정보 확인 및 비밀번호 입력 후 <span className='rf-font'>다운로드</span> 하실 수 있습니다.
              </div>
              <div className={`flex-column mt-50 ${sty.subCont}`}>
                <div>
                  이 글은 비밀글 입니다.
                </div>
                <div>
                  비밀번호를 입력하여 주시기 바랍니다.
                </div>
              </div>

              <input type='password' placeholder='비밀번호' className={`mt-50 ${sty.pwdInput}`} onChange={onPwdHandler}/>
              <button className={`mt-50 mb-300 ${sty.subBtn}`} onClick={onSubmit}>확인</button>

            </div>


          </div>
        </div>
        
    </>
  );
};

export default ProdDownPage;
